import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './_guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    data: { breadcrumb: 'Siamese Pos Intergate' },
    canActivate: [authGuard],
    children: [
      {
        path: '',
        data: { breadcrumb: 'Main' },
        loadChildren: () =>
          import('./modules/main/main.module').then((m) => m.MainModule),
      },
      {
        path: 'transaction',
        data: { breadcrumb: 'Transaction' },
        loadChildren: () =>
          import('./modules/transactions/transactions.module').then(
            (m) => m.TransactionsModule
          ),
      },
      {
        path: 'branch',
        data: { breadcrumb: 'Branches' },
        loadChildren: () =>
          import('./modules/branch/branch.module').then((m) => m.BranchModule),
      },
      {
        path: 'user-manage',
        data: { breadcrumb: 'User Management' },
        loadChildren: () =>
          import('./modules/user-manage/user-manage.module').then(
            (m) => m.UserManageModule
          ),
      },
      {
        path: 'job-schedules',
        data: { breadcrumb: 'Job Schedules' },
        loadChildren: () =>
          import('./modules/job-schedules/job-schedules.module').then(
            (m) => m.JobSchedulesModule
          ),
      },
       {
        path: 'report',
        data: { breadcrumb: 'Report' },
        loadChildren: () =>
          import('./modules/report/report.module').then(
            (m) => m.ReportModule
          ),
      },
    ],
  },
  {
    path: 'error',
    data: { breadcrumb: 'Error Page' },
    loadChildren: () =>
      import('./modules/error-page/error-page.module').then(
        (m) => m.ErrorPageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
];
